<template lang="pug"> 
  v-card(flat tile width='100%').halfColor
    v-row.mx-1.mx-sm-5
      v-col(cols='12' md='3')
        v-card.py-3(flat height="100%" dark color='var(--bg-secondary-color)')
          v-row(no-gutters align="center" style="height:100%;")
            //- v-col(cols=12 v-if="isMobile") 
            //-   steper-daily
            v-col(cols=12  v-if="!isMobile").px-3
              h3 {{ $t('credit-balance') }} 
            v-col(cols=12 ).px-3
              v-row(align="center" no-gutters)
                .mr-2
                  v-img( 
                    width="24"
                    :src="require('@/assets/anything/Wallet.svg')"
                  )   
                h3 {{ creditAmount | currency }}
                v-spacer
                v-btn.ml-3(
                  fab 
                  depressed 
                  small 
                  color='white' 
                  :to='{ name:ROUTE_DEPOSIT }' 
                  @click='GA'
                )
                  v-icon(color='var(--bg-secondary-color)') mdi-plus 
      //- v-col(cols=9 lg=6 v-if="!isMobile") 
      //-   steper-daily
</template>
<script>
// import SteperDaily from './StepperDaily'
import {  
  ROUTE_DEPOSIT
} from '@/const/route'
export default { 
  // components : {
  //   SteperDaily
  // },
  computed : {
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    creditAmount () {
      return (this.wallet || {}).amount
    },
    wallet () {
      return this.$store.getters['userProfile/GETTERS_WALLET']
    },
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    }
  }, 
  methods : { 
    GA () {
      this.$ga.event('Button', 'Deposit', 'LottoPage','' ) 
    }
  }
}
</script>
<style scoped>
.halfColor {  
  height: 100%;
  background: linear-gradient(180deg, var(--bg-main-color) 50%, var(--bg-home) 50%);
}
</style>